// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"435bb578","453":"daa73e7c"}[chunkId] + ".chunk.js";
};